import store from '@/store'
import settings from '@/settings.js'
export default function getPageTitle(pageTitle) {
    console.log(store.state.user.sysInfo)
  const title = store.state.user.sysInfo?store.state.user.sysInfo.name:settings.title
    if (pageTitle) {
        return `${pageTitle} - ${title}`
    }
    return `${title}`
}
